import { render, staticRenderFns } from "./StatisticsRespondent.vue?vue&type=template&id=194dd678"
import script from "./StatisticsRespondent.vue?vue&type=script&lang=js"
export * from "./StatisticsRespondent.vue?vue&type=script&lang=js"
import style0 from "./StatisticsRespondent.vue?vue&type=style&index=0&id=194dd678&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports